const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const addAdmin = async (userData) => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${API_BASE_URL}/admin/user/admin-accounts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(userData)
        });

        const data = await response.json();

        if (!response.ok) {
            throw data;
        }

        return data;
    } catch (error) {
        console.error('Ошибка при добавлении администратора:', error);
        throw error;
    }
};